// @flow
import invariant from 'invariant';
import { isNotEmpty } from 'utils/functional';
import { configString } from 'utils/config';

export default (passedApiKey?: ?string): { appId: string, apiKey: string } => {
  const appId = configString('algolia', 'appId');
  const apiKey = passedApiKey || configString('algolia', 'searchApiKey');
  invariant(isNotEmpty(appId), 'appId cannot be empty');
  invariant(isNotEmpty(apiKey), 'apiKey cannot be empty');
  return { appId, apiKey };
};
